var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"c-forms-settings-field"}},[(_setup.builderState.selectedField?.placeholderSelected)?_c(_setup.AddField,{attrs:{"builder-state":_setup.builderState}}):_vm._e(),_vm._v(" "),_c(_setup.MsAjaxTemplate,{attrs:{"template-name":"build-field-settings","ready-dependencies":_setup.readyDependencies}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }